import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Button} from '@chakra-ui/react'
import { ColumnSettingSelect } from './ColumnSettingsSelect'
import { ColumnSettingsTag } from './ColumnSettingsTags'
import { useState } from 'react'
import { getCountedColumns } from 'utlis/countedColumns'


export const ColumnSettingsModal = ({isOpen, onClose, counting, selectedColumns, setSelectedColumns}) => {
        /*const HandleSelect = (value) => {
        console.log(value)
    }*/

    const columns = getCountedColumns (counting)

    //const [selectedColumns, setSelectedColumns] = useState ([])
    
    const handleAddColumn = (column) => {
    setSelectedColumns(prev => [...prev, column])
    }

    const availableColumns = columns.filter(column =>
        !selectedColumns.some(selected => selected.name === column.name)
    )

    const handleRemoveColumn = (name) => {
        setSelectedColumns(prev => prev.filter(column => column.name !== name) 
    )
    }

    const handleClearColumns = () => {
        setSelectedColumns([])
    }
    

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                 <ModalHeader>Column Settings</ModalHeader>
                 <ModalCloseButton />
                 <ModalBody>
                    <ColumnSettingSelect columns={availableColumns} onChange={handleAddColumn} /*counting = {counting} */ />
                    {selectedColumns.map(column => (
                    <ColumnSettingsTag key={column.name} label={column.title} onRemove={() => handleRemoveColumn(column.name)} />
                    ))}
                 </ModalBody>
                 <ModalFooter justifyContent='space-between'>
                    <Button colorScheme='red' onClick = {handleClearColumns}>Clear</Button>
                    <Button colorScheme='green' onClick = {onClose}>OK</Button>
                 </ModalFooter>
            </ModalContent>
        </Modal>
    )
}